import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { ComponentBaseProps } from "models/propTypes/basePropTypes";
//#endregion
//#region components
import LoadingWithLogo from "./loadingWithLogo";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const LoadingWithLogoFixed: React.FC<ComponentBaseProps> = (props) => {
  const collapsed = useSelector((store: AppState) => store.util.leftNavCollapsed);

  return <LoadingWithLogo className={clsx(cssExports.fillPageLoading, collapsed ? cssExports.navCollapsed : "")} />;
};

export default LoadingWithLogoFixed;
